import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOneWayFee = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 87.636269 120.47914",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-4278.2 2578.8)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m4345.5-2555.1c-8.2261 0-23.373 0.1633-23.373 0.1633s2.2834-5.6869 2.2398-8.3902-2.4142-2.4232-2.4142-2.4232l-25.346 16.999 24.215 16.883s4.1733 1.1665 3.625-1.3099c-0.6525-2.9472-2.175-8.7326-2.175-8.7326l23.078-0.1632 0.1504-13.026z",
				fillRule: "evenodd",
				stroke: "#000",
				strokeWidth: .60284
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m4284.9-2577.7h74.161c3.1229 0 5.637 2.5141 5.637 5.637v107c0 3.1229-2.5141 5.637-5.637 5.637h-74.161c-3.1229 0-5.6371-2.5141-5.6371-5.637v-107c0-3.1229 2.5142-5.637 5.6371-5.637z",
				fill: "none",
				stroke: "#000",
				strokeWidth: 2.2013
			}),
			/* @__PURE__ */ _jsx("path", {
				transform: "scale(1.0492 .95313)",
				d: "m4096.1-2628.2c0-1.723 0.2577-3.1691 0.7731-4.3383 0.3845-0.8614 0.9095-1.6345 1.5749-2.3191s1.3941-1.1922 2.1864-1.5229c1.0538-0.4462 2.2691-0.6692 3.6459-0.6692 2.4922 0 4.4863 0.773 5.9824 2.3191s2.2441 3.6959 2.2441 6.4496c0 2.7306-0.7423 4.867-2.2268 6.4092s-3.4691 2.3134-5.9535 2.3134c-2.5153 0-4.5152-0.7673-5.9997-2.3018s-2.2268-3.6479-2.2268-6.34zm3.5191-0.1154c-1e-4 1.9153 0.4422 3.3671 1.3268 4.3555s2.0076 1.4826 3.369 1.4826 2.4787-0.4903 3.3518-1.4711 1.3095-2.4517 1.3095-4.4132c0-1.9383-0.425-3.3844-1.2749-4.3382s-1.9788-1.4307-3.3864-1.4307-2.5421 0.4827-3.4036 1.448-1.2923 2.421-1.2922 4.3671zm15.576 8.4687v-16.914h3.3229l6.9227 11.296v-11.296h3.1729v16.914h-3.4268l-6.8188-11.03v11.03h-3.1729zm17.041 0v-16.914h12.542v2.8614h-9.1264v3.7498h8.4919v2.8498h-8.4919v4.6036h9.4495v2.8498h-12.865zm-35.006 23.63-4.0382-16.914h3.496l2.5498 11.619 3.0921-11.619h4.0613l2.9653 11.815 2.596-11.815h3.4382l-4.1074 16.914h-3.6229l-3.369-12.646-3.3575 12.646h-3.7037zm35.144 0h-3.7152l-1.4768-3.8421h-6.7612l-1.3961 3.8421h-3.6228l6.5881-16.914h3.6113l6.7727 16.914zm-6.2881-6.692-2.3307-6.2765-2.2844 6.2765h4.6151zm12.553 6.692v-7.1189l-6.1958-9.7956h4.0036l3.9806 6.692 3.8998-6.692h3.9344l-6.2189 9.8187v7.0958h-3.4037z"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgOneWayFee);
export { ForwardRef as ReactComponent };
